import { t } from "@/i18n-js/instance";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { useIsGoogleSignupEnabled } from "@circle-react/components/OnboardingPage/hooks/useIsGoogleSignupEnabled";
import { useIsNewOnboardingFlow } from "@circle-react/components/OnboardingPage/hooks/useIsNewOnboardingFlow";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { getSocialProviders } from "./socialProviders";

export const SignupOptions = () => {
  const { currentCommunity } = useCurrentCommunityContext();
  const { isNewOnboardingFlow } = useIsNewOnboardingFlow();
  const { isGoogleSignupEnabled, isLoading: isGoogleLoading } =
    useIsGoogleSignupEnabled();

  const socialProviders = getSocialProviders({
    googleEnabled: isGoogleSignupEnabled && !isGoogleLoading,
  });

  if (!isNewOnboardingFlow || currentCommunity) {
    return null;
  }

  return (
    <>
      <div className="flex w-full flex-row gap-x-4">
        {socialProviders.map(({ key, logo, translationKey }) => (
          <a
            key={key}
            href={authenticationAppRoutes.socialSignIn(
              key,
              currentCommunity?.id,
            )}
            data-method="post"
            className="flex-1"
          >
            <Button
              full
              extraLarge
              className="flex items-center justify-center rounded-lg border border-gray-200 !bg-white hover:opacity-90"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <img
                  src={logo}
                  alt={t(translationKey)}
                  className="h-4 w-4"
                  loading="lazy"
                />
              </span>
            </Button>
          </a>
        ))}
      </div>

      <div className="my-6 flex items-center">
        <div className="grow border-t border-gray-200" />
        <div className="mx-4">
          <Typography.LabelSm color="text-lightest" textTransform="lowercase">
            {t("or")}
          </Typography.LabelSm>
        </div>
        <div className="grow border-t border-gray-200" />
      </div>
    </>
  );
};
